// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/arrow.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.slick-slide {
  height: inherit;
  border-bottom: 1px solid #E0E0E3;
  display: inline-block;
  list-style-type: none;
  font-size: 16px;
  font-weight: 400;
  padding-bottom: 10px;
  cursor: pointer;
}

.slick-slider .slick-list {
  width: inherit;
  height: 30px;
  padding: 0;
  margin: 0;
  border-bottom: 1px solid #E0E0E3;
  position: relative;
}
.slick-slider .slick-list .slick-track .slick-slide {
  height: 30px;
  line-height: 28px;
  border-bottom: 1px solid #E0E0E3;
  display: inline-block;
  list-style-type: none;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  margin-left: 30px;
}
.slick-slider .slick-list .slick-track .slick-slide:first-of-type {
  margin: 0;
}
.slick-slider .slick-list .slick-track .slick-slide.slick-active, .slick-slider .slick-list .slick-track .slick-slide:hover {
  color: #00007A;
  border-color: #00007A;
}
.slick-slider .slick-arrow {
  width: 70px;
  height: 100%;
  position: absolute;
  top: 0;
  z-index: 1;
  border: 0;
  cursor: pointer;
  font-size: 0;
}
.slick-slider .slick-arrow.slick-prev {
  width: 40px;
  left: 0;
  background: linear-gradient(-90deg, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 80%);
}
.slick-slider .slick-arrow.slick-prev::before {
  float: left;
  transform: rotate(180deg);
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.slick-slider .slick-arrow.slick-prev:not(.slick-disabled) + .slick-list {
  margin-left: 30px;
}
.slick-slider .slick-arrow.slick-next {
  right: 0;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgb(255, 255, 255) 60%);
}
.slick-slider .slick-arrow.slick-next::before {
  float: right;
  content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.slick-slider .slick-arrow.slick-disabled {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/reporting/components/Submenu/Submenu.scss","webpack://./src/components/reporting/styles/colors.scss"],"names":[],"mappings":"AAEA;EACE,eAAA;EACA,gCAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,eAAA;AAmBF;;AAdE;EACE,cAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,gCAAA;EACA,kBAAA;AAiBJ;AAdM;EACE,YAAA;EACA,iBAAA;EACA,gCAAA;EACA,qBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AAgBR;AAdQ;EACE,SAAA;AAgBV;AAbQ;EAEE,cChCF;EDiCE,qBCjCF;AD+CR;AARE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;AAUJ;AARI;EACE,WAAA;EACA,OAAA;EACA,sFAAA;AAUN;AARM;EACE,WAAA;EACA,yBAAA;EACA,gDAAA;AAUR;AAPM;EACE,iBAAA;AASR;AALI;EACE,QAAA;EACA,qFAAA;AAON;AALM;EACE,YAAA;EACA,gDAAA;AAOR;AAHI;EACE,wBAAA;AAKN","sourcesContent":["@use 'components/reporting/styles/colors.scss';\n\n.slick-slide {\n  height: inherit;\n  border-bottom: 1px solid colors.$grey4;\n  display: inline-block;\n  list-style-type: none;\n  font-size: 16px;\n  font-weight: 400;\n  padding-bottom: 10px;\n  cursor: pointer;\n}\n\n.slick-slider{\n\n  .slick-list{\n    width: inherit;\n    height: 30px;\n    padding: 0;\n    margin: 0;\n    border-bottom: 1px solid colors.$grey4;\n    position: relative;\n\n    .slick-track{\n      .slick-slide{\n        height: 30px;\n        line-height: 28px;\n        border-bottom: 1px solid colors.$grey4;\n        display: inline-block;\n        list-style-type: none;\n        font-size: 16px;\n        font-weight: 400;\n        cursor: pointer;\n        margin-left: 30px;\n\n        &:first-of-type{\n          margin: 0;\n        }\n\n        &.slick-active,\n        &:hover{\n          color: colors.$blue1;\n          border-color: colors.$blue1;\n        }\n      }\n    }\n  }\n\n  .slick-arrow{\n    width: 70px;\n    height: 100%;\n    position: absolute;\n    top: 0;\n    z-index: 1;\n    border: 0;\n    cursor: pointer;\n    font-size: 0;\n\n    &.slick-prev{\n      width: 40px;\n      left: 0;\n      background: linear-gradient(-90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 80%);\n\n      &::before{\n        float: left;\n        transform: rotate(180deg);\n        content: url(../../../../assets/arrow.svg);\n      }\n\n      &:not(.slick-disabled) + .slick-list{\n        margin-left: 30px;\n      }\n    }\n\n    &.slick-next{\n      right: 0;\n      background: linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 60%);\n\n      &::before{\n        float: right;\n        content: url(../../../../assets/arrow.svg);\n      }\n    }\n\n    &.slick-disabled{\n      display: none!important;\n    }\n  }\n}","$dark: #121217;\n$light: #FFFFFF;\n\n$grey1: #3E3E50;\n$grey2: #838390;\n$grey3: #C3C3C9;\n$grey4: #E0E0E3;\n$grey5: #F9F9FA;\n\n$blue1: #00007A;\n$blue2: #0000C9;\n$blue3: #4343FF;\n$blue4: #8686FF;\n$blue5: #D8D8FF;\n$blueLogo: #000093;\n\n$orange1: #DA8200;\n$orange2: #FFA92C;\n$orange3: #FFC26B;\n$orange4: #FFE1B7;\n$orange5: #FFF3E3;\n\n$green1: #033E0F;\n$green2: #218214;\n$green3: #58B441;\n$green4: #89D96B;\n$green5: #E1F8CE;\n\n$brick1: #7D1F01;\n$brick2: #B94402;\n$brick3: #E78D3D;\n$brick4: #FBD298;\n$brick5: #FDEBCB;\n\n$red1: #540726;\n$red2: #7C1028;\n$red3: #BD454A;\n$red4: #F4ADA1;\n$red5: #F9D9CF;\n\n\n:export {\n    light: $light;\n    dark: $dark;\n    blue1: $blue1;\n    blue2: $blue2;\n    blue3: $blue3;\n    blue4: $blue4;\n    blue5: $blue5;\n    orange1: $orange1;\n    orange2: $orange2;\n    orange3: $orange3;\n    orange4: $orange4;\n    orange5: $orange5;\n    grey1: $grey1;\n    grey2: $grey2;\n    grey3: $grey3;\n    grey4: $grey4;\n    grey5: $grey5;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"light": `#FFFFFF`,
	"dark": `#121217`,
	"blue1": `#00007A`,
	"blue2": `#0000C9`,
	"blue3": `#4343FF`,
	"blue4": `#8686FF`,
	"blue5": `#D8D8FF`,
	"orange1": `#DA8200`,
	"orange2": `#FFA92C`,
	"orange3": `#FFC26B`,
	"orange4": `#FFE1B7`,
	"orange5": `#FFF3E3`,
	"grey1": `#3E3E50`,
	"grey2": `#838390`,
	"grey3": `#C3C3C9`,
	"grey4": `#E0E0E3`,
	"grey5": `#F9F9FA`
};
export default ___CSS_LOADER_EXPORT___;
